class DynamicProductCard extends HTMLElement {
  connectedCallback() {
    this.render();
    this.initListeners();
  }

  render() {
    this.innerHTML = `
      <product-card class="product-item product-item-v2">
        <main-product data-handle="${this.getAttribute('handle')}" data-view="product-card" card>
            <div class="product-item__inner">
              <div class="product-item__images">
                <a href="/products/${this.getAttribute('handle')}" class="product-item__link">
                  <img src="${this.getAttribute('image')}" alt="${this.getAttribute('title')}" loading="lazy" class="product-item__image product-item__media" src="${this.getAttribute('image')}">
                </a>
              </div>
              <div class="product-item__content">
                <div class="product-item__text">
                    <div class="product-item__bar-container">
                      <div class="product-item__bar">
                        <h5 class="heading-small product-item__title">
                          <a href="/products/${this.getAttribute('handle')}">
                            ${this.getAttribute('title')}
                          </a>
                        </h5>
                      </div>
                    </div>
                </div>
              </div>
            </div>
        </main-product>
      </product-card>
    `;
  }

  initListeners() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this.load();
          this.observer.disconnect();
        }
      });
    }, {
      rootMargin: "500px 0px 500px 0px",
      threshold: 0
    });
    this.observer.observe(this);
  }

  load() {
    this.querySelector('main-product').dispatchEvent(new CustomEvent("product-change", {
      detail: this.getAttribute('handle'),
    }));
  }
}

customElements.define("dynamic-product-card", DynamicProductCard);
